import { useCallback, useState } from "react";
import { useNotify } from "react-admin";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import { candidateRequests } from "api/candidateApi";
import LoadingActionButton from "server/components/LoadingActionButton";
import { getFileFromUrl } from "server/components/DownloadFile";
import { settings } from "app";
import { generateFileName } from "./utils";

const PreviewExamProtocolButton = ({ exam, slotId }) => {
  const notify = useNotify();

  const [loading, setLoading] = useState(false);

  const previewProtocol = useCallback(async () => {
    setLoading(true);
    let fileName = await generateFileName(exam);

    fileName = slotId ? `${fileName}_slot${slotId}` : fileName;

    const url = `${settings.gatewayApi}/${candidateRequests.getCampaignExamProtocol(exam.campaignExamId)}${
      slotId ? `?slotId=${slotId}` : ""
    }`;

    await getFileFromUrl(url, fileName, notify);

    setLoading(false);
  }, [exam, notify, slotId]);

  if (!exam) {
    return null;
  }

  return (
    <LoadingActionButton
      label="Квесторски протокол"
      icon={<ContentPasteIcon />}
      onClick={previewProtocol}
      loading={loading}
    />
  );
};

export default PreviewExamProtocolButton;
